import type {
    AccommodationResourceImageReferenceTag,
    AccommodationResourceImageReferenceTagMeta} from "@@/shared/acquire/resources/resource-accommodation/accommodation-types/accommodation-resource-image-reference-tags";
import {
    accommodationResourceImageReferenceTagMeta,
    accommodationResourceImageReferenceTagZodEnum,
    accommodationResourceImageReferenceTags,
} from "@@/shared/acquire/resources/resource-accommodation/accommodation-types/accommodation-resource-image-reference-tags";
import type { RequiredTranslatable } from "@@/shared/translations/translation";
import { z } from "zod";

const resourceImageReferenceTags = [
    ...accommodationResourceImageReferenceTags,
] as const;

type ResourceImageReferenceTag = (typeof resourceImageReferenceTags)[number];
const resourceImageReferenceTagZodEnum = z.enum(resourceImageReferenceTags);

type ResourceImageReferenceTagMeta = {
    [Tag in ResourceImageReferenceTag]: {
        tag: Tag;
        title: RequiredTranslatable;
    };
};

const resourceImageReferenceTagMeta: ResourceImageReferenceTagMeta = {
    ...accommodationResourceImageReferenceTagMeta,
} as const;

export {
    accommodationResourceImageReferenceTagMeta,
    accommodationResourceImageReferenceTagZodEnum,
    accommodationResourceImageReferenceTags,
    resourceImageReferenceTagMeta,
    resourceImageReferenceTagZodEnum,
    resourceImageReferenceTags,
};
export type {
    AccommodationResourceImageReferenceTag,
    AccommodationResourceImageReferenceTagMeta,
    ResourceImageReferenceTag,
    ResourceImageReferenceTagMeta,
};
